import {Grid} from "@mui/material";

export default function Pricing() {

    const customerEmail = JSON.parse(localStorage.getItem("mqadusr"));

    return (<>
        <Grid container spacing={3} padding={2} alignItems={"center"} justifyContent={"center"}>
            <Grid item xs={12}>
                <stripe-pricing-table pricing-table-id="prctbl_1P9yB3BfR5m0xlwA2R3BayuP"
                                      publishable-key="pk_test_51NYDIdBfR5m0xlwA0dRX3fHUBHSAyRtHuEVj87jf1kGQczIuLOAKBXF6kxltvt552SURhnkabwYFkIAVXNc73R1b00fUaipUaa"
                                      customer-email={customerEmail.email}>
                </stripe-pricing-table>
            </Grid>
        </Grid>
    </>)
}